var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-empty-content"},[(_vm.type==1)?_c('img',{attrs:{"src":require("../../images/empty_data.png"),"alt":""}}):(_vm.type==2)?_c('img',{attrs:{"src":require("../../images/empty_study.png"),"alt":""}}):_c('img',{attrs:{"src":require("../../images/empty-data.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }